import { EyeShow, EyeHide } from '../../../assets/svg';
import {
  TableCell,
  Tooltip,
  Checkbox,
  TableSortLabel,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { isFunction } from 'lodash';
import React from 'react';

const TableCellFilted = ({
  label,
  stateValue,
  hiddenRows = {},
  setHiddenRows,
  style = {},
  useCheckBox,
  isChecked,
  onCheckboxChange,
  className,
  sortBy = '',
  onSortChange,
  sortOption = {},
  isSort = false,
  isHidden = true,
  colSpan = 1,
}) => {
  const checked = isFunction(isChecked) ? isChecked() : isChecked;
  const isCurrentSort = sortBy === sortOption.by;
  const direction = sortOption.dir;
  let icon = ArrowDropDownIcon;
  if (!isCurrentSort && !hiddenRows[stateValue]) {
    icon = ImportExportIcon;
  }
  return (
    <TableCell colSpan={colSpan} className={className} style={style}>
      <TableSortLabel
        active={!hiddenRows[stateValue] && (sortBy === sortOption.by || isSort)}
        direction={direction}
        hideSortIcon={!sortBy || hiddenRows[stateValue]}
        onClick={() => {
          sortBy && !hiddenRows[stateValue] && onSortChange();
        }}
        IconComponent={icon}
      >
        <div style={{ display: 'flex', alignItems: 'center', ...style }}>
          {useCheckBox && (
            <Checkbox
              color="primary"
              checked={checked}
              onChange={onCheckboxChange}
            />
          )}
          {!hiddenRows[stateValue] && label}
          {isHidden && (
            <Tooltip title={label}>
              {!hiddenRows[stateValue] ? (
                <EyeShow
                  className="eye-custom-color"
                  onClick={(e) => {
                    e.stopPropagation();
                    setHiddenRows({
                      ...hiddenRows,
                      [stateValue]: true,
                    });
                  }}
                />
              ) : (
                <EyeHide
                  className="eye-custom-color"
                  onClick={(e) => {
                    e.stopPropagation();
                    setHiddenRows({
                      ...hiddenRows,
                      [stateValue]: false,
                    });
                  }}
                />
              )}
            </Tooltip>
          )}
        </div>
      </TableSortLabel>
    </TableCell>
  );
};

export default TableCellFilted;
